import React from 'react';
import { Select, Form } from 'antd';
import { FormItemProps } from 'antd/lib/form';
import { NamePath } from 'rc-field-form/lib/interface';

export const getDurationDisplay = (duration: number): string => {
  const hours = Math.floor(duration / 60);
  const minutes = Math.floor(duration % 60);
  return `${hours}h ${minutes}m`;
};

export interface DurationSelectOption {
  value: number;
  label: string;
}

export const getDurationOptions = (start: number, max: number, step: number): DurationSelectOption[] => {
  const options: DurationSelectOption[] = [];
  for (let i = start; i <= max; i = i + step) {
    options.push({ value: i, label: getDurationDisplay(i) });
  }
  return options;
};

export interface IDurationDropdownProps extends FormItemProps {
  name?: NamePath;
  disabled?: boolean;
  value?: any;
  onChange?: (value: any, option: any) => void;
}

const DurationDropdown = (props: IDurationDropdownProps) => {
  const step = 15; // minutes
  const start = 15; // 0h 15m
  const max = 1440; // 24 hours

  const selectOptions = getDurationOptions(start, max, step);

  const handleChange = (value: any, option: any) => {
    if (props.onChange) props.onChange(value, option);
  };

  return (
    <>
      <Form.Item name={props.name} label={props.label} rules={props.rules} valuePropName="value" className={`relative ${props.className || ''}`}>
        <Select getPopupContainer={(trigger) => trigger.parentElement} disabled={props.disabled} onChange={handleChange} defaultValue={props.value}>
          {selectOptions.map((i) => (
            <Select.Option key={`dropdown_${props.label}_${i.value}`} value={i.value}>
              {i.label}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
    </>
  );
};

export default DurationDropdown;
